import { ThemeLayout } from '../../front/lib/ThemeLayout';
import { makeFoldable } from '../../front/shared';
import { initScrollForTables } from '../../front/content-rich/tables';
import { SliderGallery } from '../../modules/SliderGallery/SliderGallery';
import { theme } from '../../front/Theme';
import { createGenericModal } from '../../front/components';
export class SingleProduct extends ThemeLayout {
    constructor() {
        super(...arguments);
        this.variableContentEl = this.getElementById('variableContent');
        this.printAsideEl = this.getElementById('printMe');
        this.variationsMap = new Map();
        this.activeVariationId = null;
    }
    async init() {
        if (this.variableContentEl) {
            await this.initVariableContent(this.variableContentEl);
            this.initVariations();
        }
        if (this.printAsideEl) {
            document.body.appendChild(this.printAsideEl);
            const contactFormButtonMod = document.querySelector('.contactFormButtonMod');
            if (contactFormButtonMod) {
                this.printAsideEl.prepend(contactFormButtonMod);
            }
        }
        if (this.json.print) {
            this.initPrintUi(this.json.print);
        }
    }
    initSpreadsheetGroups(rootEl) {
        for (const el of [].slice.apply(rootEl.querySelectorAll('.spreadsheetGroup'))) {
            initSpreadsheetGroup(el);
        }
        function initSpreadsheetGroup(el) {
            const buttonEls = [].slice.apply(el.querySelectorAll('button[data-tab-id]'));
            const contentEls = [].slice.apply(el.querySelectorAll('.spreadsheetGroup-tab[data-tab-id]'));
            const wrapperEl = el.querySelector('.spreadsheetGroup-content');
            makeTabActive(buttonEls[0], contentEls[0]);
            el.addEventListener('click', event => {
                const buttonEl = event.target.closest('button[data-tab-id]');
                if (buttonEl) {
                    const tabId = buttonEl.dataset.tabId;
                    const contentEl = contentEls.find(el => el.dataset.tabId === tabId);
                    if (contentEl) {
                        makeTabActive(buttonEl, contentEl);
                    }
                }
            });
            function makeTabActive(buttonEl, contentEl) {
                for (const otherBtnEl of buttonEls) {
                    otherBtnEl.classList.remove('is--active');
                    otherBtnEl.classList.replace('accentColor--black', 'accentColor--gray');
                }
                buttonEl.classList.add('is--active');
                buttonEl.classList.replace('accentColor--gray', 'accentColor--black');
                if (contentEl) {
                    for (const otherContentEls of contentEls) {
                        otherContentEls.classList.remove('is--active');
                    }
                    contentEl.classList.add('is--active');
                    adjustWrapperHeight();
                }
            }
            function adjustWrapperHeight() {
                wrapperEl.style.height = contentEls.filter(el => el.classList.contains('is--active'))[0].clientHeight + 'px';
            }
        }
    }
    initVariations() {
        const variationsEl = this.getElementById('variations');
        if (!variationsEl) {
            return;
        }
        const linksEls = [].slice.apply(variationsEl.querySelectorAll('a[data-product-id]'));
        if (!linksEls.length) {
            return;
        }
        const highlightActiveLinks = (productId) => {
            linksEls
                .forEach(l => this.applyInactiveBtnStyles(l));
            linksEls
                .filter(l => l.dataset.productId === productId.toString())
                .forEach(l => this.applyActiveBtnStyles(l));
        };
        for (const a of linksEls) {
            const productId = parseInt(a.dataset.productId);
            if (a.classList.contains('is--active')) {
                this.activeVariationId = productId;
                highlightActiveLinks(productId);
            }
            a.addEventListener('click', e => {
                e.preventDefault();
                switchVariableContent(productId).then(() => {
                    window.history.pushState({ productId: productId }, '', a.href);
                });
                if (this.printAsideEl) {
                    const printLinkEl = this.printAsideEl.querySelector('a');
                    if (printLinkEl) {
                        printLinkEl.href = a.dataset.printableUrl;
                    }
                }
            });
        }
        // Populate current history state with the active variation product ID
        window.history.replaceState({ productId: this.activeVariationId }, '', location.href);
        // Listen for popstate events to switch variable content back and forth
        window.addEventListener('popstate', e => {
            var _a;
            if (((_a = e.state) === null || _a === void 0 ? void 0 : _a.productId) && this.activeVariationId !== parseInt(e.state.productId)) {
                switchVariableContent(parseInt(e.state.productId));
            }
        });
        const switchVariableContent = async (productId) => {
            if (this.activeVariationId === productId) {
                return;
            }
            this.variableContentEl.classList.add('is--loading');
            highlightActiveLinks(productId);
            if (this.activeVariationId) {
                // Cache the current variable content
                const els = [];
                for (const child of [].slice.apply(this.variableContentEl.children)) {
                    els.push(child);
                }
                this.variationsMap.set(this.activeVariationId, els);
            }
            const cachedEls = this.variationsMap.get(productId);
            if (!cachedEls) {
                // Fetch the variable content
                try {
                    const resp = await this.restRequest('GET', `variable-content/${productId}?locale=${theme().json.i18n.locale}`);
                    if (resp.payload.html) {
                        this.variableContentEl.innerHTML = resp.payload.html;
                        await this.initVariableContent(this.variableContentEl);
                        initScrollForTables(this.variableContentEl);
                    }
                    else {
                        throw new Error('No HTML in response');
                    }
                }
                catch (err) {
                    console.warn(err);
                    alert('Failed to load variable content');
                }
            }
            else {
                // Use the cached variable content
                this.variableContentEl.innerHTML = '';
                for (const el of cachedEls) {
                    this.variableContentEl.appendChild(el);
                }
            }
            this.activeVariationId = productId;
            this.variableContentEl.classList.remove('is--loading');
            this.adjustSliderGalleriesScrollbars();
        };
    }
    async initVariableContent(rootEl) {
        const foldables = [];
        this.initSpreadsheetGroups(rootEl);
        this.querySelectorAll('section').forEach((section) => {
            const headerEl = section.querySelector('header[aria-controls]');
            if (!headerEl) {
                return;
            }
            const contentEl = document.getElementById(headerEl.getAttribute('aria-controls'));
            if (!contentEl) {
                return;
            }
            const innerEl = contentEl.children[0];
            if (!innerEl) {
                return;
            }
            foldables.push(makeFoldable({
                clickAreas: [headerEl],
                container: contentEl,
                innerContainer: innerEl,
            }));
            // Adjust height of the foldable content after Swiper slider is initialized
            // Otherwise, the height of the foldable content will be incorrect
            const sliderGalleries = this.findParts(SliderGallery);
            for (const sliderGallery of sliderGalleries) {
                sliderGallery.afterSliderInit(swiper => {
                    foldables.forEach(f => !f.isFolded() && f.unfold());
                });
            }
        });
    }
    adjustSliderGalleriesScrollbars() {
        var _a, _b;
        const sliderGalleries = this.findParts(SliderGallery);
        for (const sliderGallery of sliderGalleries) {
            (_b = (_a = sliderGallery.swiperInstance) === null || _a === void 0 ? void 0 : _a.scrollbar) === null || _b === void 0 ? void 0 : _b.updateSize();
        }
    }
    applyActiveBtnStyles(el) {
        el.classList.remove('fill--outline', 'accentColor--dark');
        el.classList.add('is--active');
    }
    applyInactiveBtnStyles(el) {
        el.classList.add('fill--outline', 'accentColor--dark');
        el.classList.remove('is--active');
    }
    async initPrintUi(args) {
        const modal = createGenericModal({
            title: args.strings.print_product,
            dismissible: false,
            classes: ['no--print'],
            bodyHtml: args.strings.description_html,
            actions: [
                {
                    title: args.strings.print,
                    icon: 'printer',
                    fill: 'solid',
                    handler: () => {
                        window.print();
                    },
                },
                {
                    title: args.strings.close,
                    icon: 'times',
                    color: 'neutral',
                    handler: () => {
                        window.location.href = args.originalUrl || '/';
                    },
                }
            ],
        });
        return modal.show();
    }
}
